

















import { Component, Vue, Prop } from "vue-property-decorator";
import BinaryInput from "@/basics/inputs/BinaryInput.vue";

export interface CheckBoxItem {
  name: string;
  value: string;
  disabled?: boolean;
}

export interface CheckInputsClickEvent {
  index: number;
  item: CheckBoxItem;
}

@Component({
  components: { BinaryInput }
})
export default class CheckInputs extends Vue {
  @Prop({ type: Array, required: true }) items!: CheckBoxItem[];
  @Prop({ type: Array, required: false, default: () => [] }) value!: string[];

  get booleans(): boolean[] {
    return this.items.map(item => this.value.includes(item.value));
  }

  click(index: number): void {
    // クリックイベントを送信
    const event: CheckInputsClickEvent = { index, item: this.items[index] };
    this.$emit("click", event);

    // 現在の選択状態をベースにする
    const current = this.booleans;

    // クリックされたアイテムがdisabledである場合、そのまま変更せず送る
    if (this.items[index].disabled) {
      const currentValue = this.items
        .filter((_item, index) => current[index])
        .map(item => item.value);

      this.$emit("input", currentValue);
      return;
    }

    // 操作された要素のみ、値を書き換え
    current[index] = !current[index];

    // もともとのitemsから、選択されたvalueを抽出
    const latestValue: string[] = this.items
      .filter((_item, index) => current[index])
      .map(item => item.value);

    // 親要素に送信
    this.$emit("input", latestValue);
  }
}
